export const DETRACCION = 'TC001'
export const AFECTACIONVENTA = 'TC002'
export const AFECTACIONCOMPRA = 'TC003'
export const CONDICIONESDEPAGO = 'TC005'
export const DOCUMENTOSIDENTIDAD = 'TC006'
export const DOCUMENTOSUNAT = 'TC007'
export const MOTIVONOTACREDITO = 'TC008'
export const MOTIVONOTADEBITO = 'TC009'
export const TIPOEXISTENCIA = 'TC010'
export const TIPOOPERACIONSUNAT = 'TC011'
export const MOTIVOGUIAREMISION = 'TC012'
export const BANCOS = 'TC013'
export const ADUANAS = 'TC014'
export const ORIGENES = 'TC015'
export const FLUJOSEFECTIVO = 'TC016'
export const PAIS = 'TC018'
export const SUNAT_TIPO_ACTIVO_FIJO = 'TC030'
export const SUNAT_ESTADO_ACTIVO_FIJO = 'TC031'
export const DEPARTAMENTO = 'TC021'
export const PROVINCIA = 'TC022'
export const DISTRITO = 'TC023'
export const ATRIBUTOPRODUCTO = 'TC024'
export const DATOPRESUPUESTO_NIVEL1 = 'TC027'
export const DATOPRESUPUESTO_NIVEL2 = 'TC028'
export const DATOPRESUPUESTO_NIVEL3 = 'TC029'

export const __dictionary = {
  [DETRACCION]: { id: DETRACCION, nombre: 'DETRACCIONES' },
  [AFECTACIONVENTA]: { id: AFECTACIONVENTA, nombre: 'AFECTACIONES VENTA' },
  [AFECTACIONCOMPRA]: { id: AFECTACIONCOMPRA, nombre: 'AFECTACIONES COMPRA' },
  [CONDICIONESDEPAGO]: { id: CONDICIONESDEPAGO, nombre: 'CONDICIONES DE PAGO' },
  [DOCUMENTOSIDENTIDAD]: { id: DOCUMENTOSIDENTIDAD, nombre: 'DOCUMENTOS IDENTIDAD' },
  [DOCUMENTOSUNAT]: { id: DOCUMENTOSUNAT, nombre: 'DOCUMENTO SUNAT' },
  [MOTIVONOTACREDITO]: { id: MOTIVONOTACREDITO, nombre: 'MOTIVOS NOTA CREDITO' },
  [MOTIVONOTADEBITO]: { id: MOTIVONOTADEBITO, nombre: 'MOTIVOS NOTA DEBITO' },
  [TIPOEXISTENCIA]: { id: TIPOEXISTENCIA, nombre: 'TIPOS EXISTENCIA' },
  [TIPOOPERACIONSUNAT]: { id: TIPOOPERACIONSUNAT, nombre: 'TIPOS OPERACION SUNAT' },
  [MOTIVOGUIAREMISION]: { id: MOTIVOGUIAREMISION, nombre: 'MOTIVOS GUIA REMISION' },
  [BANCOS]: { id: BANCOS, nombre: 'BANCOS' },
  [ADUANAS]: { id: ADUANAS, nombre: 'ADUANAS' },
  [ORIGENES]: { id: ORIGENES, nombre: 'ORIGENES' },
  [FLUJOSEFECTIVO]: { id: FLUJOSEFECTIVO, nombre: 'FLUJOS EFECTIVO' },
  [SUNAT_TIPO_ACTIVO_FIJO]: { id: SUNAT_TIPO_ACTIVO_FIJO, nombre: 'SUNAT TIPO ACTIVO FIJO' },
  [SUNAT_ESTADO_ACTIVO_FIJO]: { id: SUNAT_ESTADO_ACTIVO_FIJO, nombre: 'SUNAT ESTADO ACTIVO FIJO' },
  [DATOPRESUPUESTO_NIVEL1]: { id: DATOPRESUPUESTO_NIVEL1, nombre: 'DATOPRESUPUESTO NIVEL1' },
  [DATOPRESUPUESTO_NIVEL2]: { id: DATOPRESUPUESTO_NIVEL2, nombre: 'DATOPRESUPUESTO NIVEL2' },
  [DATOPRESUPUESTO_NIVEL3]: { id: DATOPRESUPUESTO_NIVEL3, nombre: 'DATOPRESUPUESTO NIVEL3' }
}

export const __array = [
  __dictionary[DETRACCION],
  __dictionary[AFECTACIONVENTA],
  __dictionary[AFECTACIONCOMPRA],
  __dictionary[CONDICIONESDEPAGO],
  __dictionary[DOCUMENTOSIDENTIDAD],
  __dictionary[DOCUMENTOSUNAT],
  __dictionary[MOTIVONOTACREDITO],
  __dictionary[MOTIVONOTADEBITO],
  __dictionary[TIPOEXISTENCIA],
  __dictionary[TIPOOPERACIONSUNAT],
  __dictionary[MOTIVOGUIAREMISION],
  __dictionary[BANCOS],
  __dictionary[ADUANAS],
  __dictionary[ORIGENES],
  __dictionary[FLUJOSEFECTIVO],
  __dictionary[SUNAT_TIPO_ACTIVO_FIJO],
  __dictionary[SUNAT_ESTADO_ACTIVO_FIJO],
  __dictionary[DATOPRESUPUESTO_NIVEL1],
  __dictionary[DATOPRESUPUESTO_NIVEL2],
  __dictionary[DATOPRESUPUESTO_NIVEL3]
]
